export default __webpack_public_path__ + "static/media/Roboto-ThinItalic.1f891e03.ttf";